import { Controller } from "@hotwired/stimulus"
import jquery from "jquery";

export default class extends Controller {
  static values = {
    expandedClass: { type: String, default: 'expanded' },
    moreText: { type: String, default: 'more' },
    lessText: { type: String, default: 'less' },
    count: { type: Number, default: 5 },
  }

  static targets = ["list", "toggle"]

  connect() {
    this.isExpanded = false
    this.setupList()
  }

  setupList() {
    const items = this.listTarget.children
    const itemCount = items.length - (this.hasToggleTarget ? 1 : 0)

    if (itemCount > this.countValue) {
      this.hideExcessItems()
      if (!this.hasToggleTarget) {
        this.addToggle()
      } else {
        this.toggleTarget.style.display = ''
      }
    } else if (this.hasToggleTarget) {
      this.toggleTarget.style.display = 'none'
    }
  }

  hideExcessItems() {
    const items = this.listTarget.children
    const itemCount = items.length - (this.hasToggleTarget ? 1 : 0)
    for (let i = this.countValue; i < itemCount; i++) {
      items[i].style.display = 'none'
    }
  }

  addToggle() {
    const toggleItem = document.createElement('li')
    const items = this.listTarget.children
    const itemCount = items.length

    // Only add margin if there are visible elements (countValue > 0)
    if (this.countValue > 0) {
      toggleItem.classList.add('toggle-item', 'ml-2')
    } else {
      toggleItem.classList.add('toggle-item')
    }

    const toggleLink = document.createElement('a')
    toggleLink.href = '#'
    toggleLink.textContent = this.moreTextValue
    toggleLink.classList.add(

    )
    toggleLink.dataset.action = 'click->expandable#toggle'
    toggleLink.dataset.expandableTarget = 'toggle'
    toggleLink.dataset.captureExclude = ''

    toggleItem.appendChild(toggleLink)
    this.listTarget.appendChild(toggleItem)
  }

  toggle(event) {
    event.preventDefault()  // Prevent the default link behavior
    this.isExpanded = !this.isExpanded
    const items = this.listTarget.children
    const itemCount = items.length - 1  // Exclude the toggle item

    for (let i = this.countValue; i < itemCount; i++) {
      items[i].style.display = this.isExpanded ? '' : 'none'
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.textContent = this.isExpanded ? this.lessTextValue : this.moreTextValue
    }

    this.listTarget.classList.toggle(this.expandedClassValue)
  }

  initialize() {

  }

  disconnect() {

  }

}
